<div id="heading">
    <h1>Institutional Development Plan (Vision Plan)</h1>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item" routerLink="/"><a href="#">Home</a></li>
            <li class="breadcrumb-item"><a href="#">About Us</a></li>
            <li class="breadcrumb-item active" aria-current="page">Vision Plan</li>
        </ol>
    </nav>
</div>

<div id="vision">
    <div class="container-fluid">
        <div class="card pl-3 pr-3 text-justify ml-lg-5">
            <h4 class="card-title text-center ">Institutional Development Plan (Vision Plan)</h4>
            <div class="card-body text-justify">
                <p class="lead mb-4">
                    <iframe src="" width="100%" height="640px" allow="autoplay"></iframe>
                </p>
            </div>
        </div>
    </div>
</div>